import api from "../../../services/api";

// ================= GET DOCUMENTS =================
export const getClientDocuments = (clientId) =>
  api.get(`/client-documents/${clientId}`);


// ================= UPLOAD DOCUMENT =================
export const uploadClientDocument = (
  clientId,
  documentTypeId,
  formData
) =>
  api.post(
    `/client-documents/${clientId}/${documentTypeId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );


// ================= DELETE DOCUMENT =================
export const deleteClientDocument = (id) =>
  api.delete(`/client-documents/${id}`);


// ================= HISTORY =================
export const getDocumentHistory = (clientId, docTypeId) =>
  api.get(`/client-documents/history/${clientId}/${docTypeId}`);


// ================= DOWNLOAD =================
export const downloadClientDocument = (id) =>
  window.open(`http://backapi.ypsispma.com/api/client-documents/download/${id}`);



// ================= PREVIEW =================
export const previewClientDocument = (id) =>
  `http://backapi.ypsispma.com/api/client-documents/preview/${id}`;

